import { create } from 'zustand'

interface ChatMessage {
  id: string
  role: 'user' | 'bot' | 'system'
  content: string
  timestamp: Date
}

interface ChatState {
  messages: ChatMessage[]
  isTyping: boolean

  addMessage: (message: Omit<ChatMessage, 'id' | 'timestamp'>) => void
  setIsTyping: (typing: boolean) => void
  clearMessages: () => void
}

export const useChatStore = create<ChatState>((set) => ({
  messages: [
    {
      id: '1',
      role: 'bot',
      content: 'Hello! Welcome to Jasmine Dental Lab. How can I help you today?',
      timestamp: new Date(),
    },
  ],
  isTyping: false,

  addMessage: ({ role, content }) =>
    set((state) => ({
      messages: [
        ...state.messages,
        {
          id: Date.now().toString(),
          role,
          content,
          timestamp: new Date(),
        },
      ],
    })),

  setIsTyping: (typing) => set({ isTyping: typing }),

  clearMessages: () =>
    set({
      messages: [
        {
          id: '1',
          role: 'bot',
          content: 'Hello! Welcome to Jasmine Dental Lab. How can I help you today?',
          timestamp: new Date(),
        },
      ],
    }),
}))
